type Props = {
  label: string
  onClick: () => void
  loading?: boolean
}

export default function Button({ label, onClick, loading }: Props) {
  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={`mt-4 px-6 py-2 rounded text-white ${
        loading ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
      }`}
    >
      {loading ? "Loading..." : label}
    </button>
  )
}